function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122 72.9999C189.379 72.9999 244 65.6126 244 56.4999V38.5C244 47.6127 189.379 55 122 55C54.6213 55 0 47.6127 0 38.5V56.4999C0 65.6126 54.6213 72.9999 122 72.9999Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122 72.9999C189.379 72.9999 244 65.6126 244 56.4999V38.5H122H0V56.4999C0 65.6126 54.6213 72.9999 122 72.9999Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 38.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 38.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122 55C189.379 55 244 47.6127 244 38.5C244 38.5 244 37.5 243.5 37.5C238.5 42 224.144 45.1874 192 48C155 51.2375 113.5 51.8636 72.5 50C59.3234 49.401 6.5 45.5 0.500003 37C0 38 0 38.5 0 38.5C0 47.6127 54.6213 55 122 55Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 50.9999C195.379 50.9999 250 43.6126 250 34.4999V16.5C250 25.6127 195.379 33 128 33C60.6213 33 6 25.6127 6 16.5V34.4999C6 43.6126 60.6213 50.9999 128 50.9999Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 50.9999C195.379 50.9999 250 43.6126 250 34.4999V16.5H128H6V34.4999C6 43.6126 60.6213 50.9999 128 50.9999Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 16.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 16.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear_for_2chip)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 33C195.379 33 250 25.6127 250 16.5C250 16.5 250 15.5 249.5 15.5C244.5 20 230.144 23.1874 198 26C161 29.2375 119.5 29.8636 78.5 28C65.3234 27.401 12.5 23.5 6.5 15C6 16 6 16.5 6 16.5C6 25.6127 60.6213 33 128 33Z",
  fill: "url(#paint5_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 73,
  x2: 118,
  y2: 73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 27,
  x2: 122,
  y2: 49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 54.9999,
  x2: 244,
  y2: 54.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 51,
  x2: 124,
  y2: 51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_for_2chip",
  x1: 143,
  y1: 5,
  x2: 128,
  y2: 27,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 32.9999,
  x2: 250,
  y2: 32.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 73,
  fill: "white"
})));

function Svg2Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 73,
    viewBox: "0 0 250 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Chip);
export default __webpack_public_path__ + "static/media/2chip.0809589b.svg";
export { ForwardRef as ReactComponent };